import styles from './FullPageSpinner.module.scss';

interface FullPageSpinnerProps {
  loadingText?: string;
}

const FullPageSpinner = ({ loadingText }: FullPageSpinnerProps) => {
  return (
    <div className={styles.spinnerContainer}>
      <div className={styles.loadingContainer}>
        <div className={styles.loadingSpinner}>
          <div className={styles.loadingCore}></div>
        </div>
        <h3>{loadingText}</h3>
      </div>
    </div>
  );
};

export default FullPageSpinner;
